import { makeStyles } from "@material-ui/core/styles";
import offBackground from "assets/images/radioButtonOff.png";
import onBackground from "assets/images/radioButtonOn.png";
import { useState, forwardRef, useImperativeHandle } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

const useStyles = makeStyles((theme) => ({
  enabledButton: {
    width: "12%",
    height: "70%",
    display: "block",
    justifyContent: "center",
    marginRight: "0.75vw",
    backgroundImage: `url(${onBackground})`,
    backgroundSize: "contain",
    backgroundRepeat:"no-repeat"
  },
  disabledButton: {
    width: "12%",
    height: "70%",
    display: "block",
    justifyContent: "center",
    marginRight: "0.75vw",
    backgroundImage: `url(${offBackground})`,
    backgroundSize: "contain",
    backgroundRepeat:"no-repeat"
  },
}));

/**
 * @component LEDButton
 */

const LEDButton = forwardRef(
  ({ muted, muteFunction, layerName }, ref) => {
    const classes = useStyles();
    const [enable, setEnable] = useState(!muted);

    const handelClick = () => {
      setEnable(!enable);
      muteFunction(layerName);
    };

    useImperativeHandle(ref, () => ({
      toggleMute(){
        setEnable(!enable);
      }
    }));

    return (
      <div
        className={enable ? classes.enabledButton : classes.disabledButton}
        onClick={handelClick}
      ></div>
    );
  }
);

export default LEDButton;
